import { ShieldCheck, BadgeCheck, Award, Zap, Map, CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WHY_CHOOSE, IMAGES } from "../../data/siteData";

const icons = {
  "shield-check": ShieldCheck,
  "badge-check": BadgeCheck,
  award: Award,
  zap: Zap,
  map: Map,
  "check-circle": CheckCircle2,
};

export const WhyChoose = () => (
  <section
    id="why"
    className="section relative bg-[#050F22] overflow-hidden"
    data-testid="why-section"
  >
    <div
      className="absolute inset-0 bg-cover bg-center opacity-[0.07]"
      style={{ backgroundImage: `url('${IMAGES.workers}')` }}
    />
    <div className="container-custom relative">
      <SectionHeading
        eyebrow="Why Quanticom"
        title="Trusted To Deliver, Built On Safety"
        subtitle="The reasons Australia's leading carriers and infrastructure partners choose Quanticom for mission-critical work."
        center
      />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {WHY_CHOOSE.map((item, i) => {
          const Icon = icons[item.icon] || ShieldCheck;
          return (
            <Reveal key={item.title} delay={(i % 3) * 0.08}>
              <div
                className="group flex items-start gap-4 rounded-2xl p-6 glass hover:border-[#00D4FF]/40 transition-all duration-300 hover:-translate-y-1 h-full"
                data-testid={`why-card-${i}`}
              >
                <div className="shrink-0 w-12 h-12 rounded-xl flex items-center justify-center bg-[#00D4FF]/10 border border-[#00D4FF]/20 group-hover:bg-[#00D4FF]/20 transition-colors">
                  <Icon className="w-6 h-6 text-[#00D4FF]" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-1.5">{item.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed">{item.text}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
